import type { SearchableField } from "@salon/types";

export const BOOKING_BEHAVIOR_SEARCH: SearchableField[] = [
  {
    id: "booking_behavior.mode",
    sectionId: "booking-behavior",
    labelKey: "search.bookingBehavior.mode.label",
    descriptionKey: "search.bookingBehavior.mode.description",
    keywordsKey: "search.bookingBehavior.mode.keywords",
    anchor: "field-booking-mode",
  },
  {
    id: "booking_behavior.manual.count_pending_toward_capacity",
    sectionId: "booking-behavior",
    labelKey: "search.bookingBehavior.manualCountPending.label",
    descriptionKey: "search.bookingBehavior.manualCountPending.description",
    keywordsKey: "search.bookingBehavior.manualCountPending.keywords",
    anchor: "field-booking-manual-count-pending",
  },
  {
    id: "booking_behavior.auto.arrange_workers",
    sectionId: "booking-behavior",
    labelKey: "search.bookingBehavior.autoArrangeWorkers.label",
    descriptionKey: "search.bookingBehavior.autoArrangeWorkers.description",
    keywordsKey: "search.bookingBehavior.autoArrangeWorkers.keywords",
    anchor: "field-booking-auto-arrange-workers",
  },
  {
    id: "booking_behavior.auto.confirm_immediately",
    sectionId: "booking-behavior",
    labelKey: "search.bookingBehavior.autoConfirmImmediately.label",
    descriptionKey: "search.bookingBehavior.autoConfirmImmediately.description",
    keywordsKey: "search.bookingBehavior.autoConfirmImmediately.keywords",
    anchor: "field-booking-auto-confirm",
  },
  {
    id: "booking_behavior.auto.batch_confirm_interval",
    sectionId: "booking-behavior",
    labelKey: "search.bookingBehavior.autoBatchInterval.label",
    descriptionKey: "search.bookingBehavior.autoBatchInterval.description",
    keywordsKey: "search.bookingBehavior.autoBatchInterval.keywords",
    anchor: "field-booking-auto-batch-interval",
  },
];
